export enum OperationsConfigEnum {
    Bookings,
    WorkItems,
    CallLog,
    ClientFollowUps
}
